export const GET_APPS = "GET_APPS"
export const GET_APPS_SUCCESS = "GET_APPS_SUCCESS"
export const GET_APPS_ERROR = "GET_APPS_ERROR"

export const DELETE_APP = "DELETE_APP"
export const DELETE_APP_SUCCESS = "DELETE_APP_SUCCESS"
export const DELETE_APP_ERROR = "DELETE_APP_ERROR"